import React from "react";

// components
// import Paginate from "../../../components/ui/paginate";
import OpportunityCard from "../misc/OpportunityCard";

// state
import { get_opportunities } from "../../../service/api/opportunity";
import { setTitle } from "../../../store/slices/navbar";
import { useAppDispatch, useAppSelector } from "../../../store";
import { Loader } from "../../../components/animation/Loader";

const Opportunity = () => {
  const dispatch = useAppDispatch();
  const { opportunities, loading, limit, offset } = useAppSelector(
    ({ opportunity }) => opportunity,
  );

  const onLoad = React.useCallback(() => {
    dispatch(setTitle("Opportunity"));
    get_opportunities(dispatch, limit, offset);
  }, [dispatch, limit, offset]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  if (loading) {
    return (
      <div className="grid place-content-center h-[90svh]">
        <Loader />
      </div>
    );
  }

  return (
    <div className="">
      <div className="">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 pb-12">
          {opportunities.map((item) => (
            <OpportunityCard key={item.id} item={item} />
          ))}
        </div>
        {/* <Paginate
          current_page={current_page}
          last_page={last_page}
          onBack={() => dispatch(onBack())}
          onNext={() => dispatch(onNext())}
        /> */}
      </div>
    </div>
  );
};

export default Opportunity;
